import { useNavigate } from 'react-router-dom';
import PageHeader from '../components/layout/PageHeader';
import { EndpointForm } from '../components/endpoints/EndpointForm';
import { useCreateEndpoint } from '../hooks/useEndpoints';

export default function NewEndpointPage() {
  const navigate = useNavigate();
  const createEndpoint = useCreateEndpoint();

  const handleSubmit = async (data: any) => {
    await createEndpoint.mutateAsync(data);
    navigate('/endpoints');
  };

  return (
    <div>
      <PageHeader
        title="Create Endpoint"
        description="Create a new API endpoint"
      />
      <div className="mt-6 bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-6">
        <EndpointForm mode="create" onSubmit={handleSubmit} />
      </div>
    </div>
  );
}
